export const FETCH_POLICY = 'no-cache';
export const INITIAL_MODAL_STATE = {
  isOpen: false,
  maxValueReached: false,
  bookingAlreadyUpgradedForFree: false,
  freeUpgradeUnavailable: {},
  maxAmountPerJourney: false,
  maxAmountPerPassenger: false
};

export const MONTHLY_FREE_UPGRADE_GBP_BUDGET = 4000;

export const FREE_UPGRADE_MAX_AMOUNT_PER_JOURNEY = 300;
export const FREE_UPGRADE_MAX_AMOUNT_PER_PASSENGER = 150;
